module.exports = "<svg id=\"1133fced-80e2-4779-bca8-2fdc5e778704\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>quote</title><path d=\"M20.44,4.07c-6.38,0-11.38,2-15,5.92S0,20.12,0,28.53V46H21V27.13H10.87c0-4.62.76-8.06,2.24-10.31s3.92-3.38,7.33-3.38V4.07Zm28.82,0A23.56,23.56,0,0,0,40.74,5.5a16,16,0,0,0-6.39,4.44,20.49,20.49,0,0,0-4,7.67,38.21,38.21,0,0,0-1.4,10.92V46H50V27.13H39.87q0-6.93,2.22-10.31t7.17-3.38V4.07Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/quote.svg
// module id = 570
// module chunks = 1